import EventNotFound from './EventNotFound';

export default EventNotFound;
